import * as setup from 'setup';
import styled from 'styled-components';

export const FunnelRetentionContainer = styled.div`
    align-items: center;
    background: #ffffff;
    border-radius: 20px;
    border: 1px solid #e0e0e0;
    box-shadow: 0px 2px 40px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    color: #000000;
    display: flex;
    display: flex;
    flex-direction: column;
    font-family: inherit;
    font-size: 12px;
    font-style: normal;
    font-weight: normal;
    height: 70px;
    justify-content: center;
    line-height: 120%;
    width: 190px;
`;

export const FunnelRetentionBody = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
    padding: 3px;
    width: 200px;
    height: 40px;
    font-size: ${setup.fontSizes.h5};
`;